<template>
    <div>
        <v-app-bar>
            <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

            <v-toolbar-title>ThanhDance</v-toolbar-title>

            <v-spacer></v-spacer>

            <!---<v-btn icon @click="changeDarkMode">
                <v-icon>invert_colors</v-icon>
            </v-btn>--->
            <v-btn icon href="https://qcsnet.it/">
                <v-avatar size=40>
                    <v-img src='@/assets/logo-qcsnet.png'></v-img>
                </v-avatar>
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
        >
            <v-list
            nav
            dense
            >
            <v-list-item-group
                v-model="group"
            >
                <v-list-item to="/">
                    <v-list-item-icon>
                        <v-icon>home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item>

                <!--<v-list-item to="/account">
                    <v-list-item-icon>
                        <v-icon>account_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Account</v-list-item-title>
                </v-list-item>-->

                <v-list-item to="/settings">
                    <v-list-item-icon>
                        <v-icon>settings</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Settings</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
            </v-list>

            <div style="text-align:center;">
                <v-img style="display:inline-block;" width="60%" justify-end src='@/assets/full-logo-qcsnet.png'></v-img>
            </div>

            <div style="text-align:center;">
                <v-img style="display:inline-block;" width="60%" justify-end> V.{{APPVERSION}} <br> &copy; QCSNET SRL</v-img>
            </div>
        </v-navigation-drawer>


    </div>
</template>

<script>
  export default {
    name: 'Drawer',

    data: () => ({
      drawer: false,
      group: 0,
      APPVERSION: "0.0"
    }),

    methods:{
        changeDarkMode: function(){
            this.$store.commit('changeDarkMode', !this.$store.state.isDark)
        },
    },

    mounted: function(){
        this.$nextTick(()=>{
            this.APPVERSION = this.$cookies.get("APPVERSION")
        })
    },

    watch:{
        group: function(newVal, oldVal){
            //console.log(newval, oldval)
            //this.$store.commit("changePage", this.group)
            this.drawer = false
            if(oldVal === 0 && newVal !== 0)
                this.$store.commit("changeRunningPosenet", false)
        }
    }
  }
</script>